<template>
    <div class="select page">
        <wrapper column align="flex-start" :backgroundImage="background">
            <div class="float image-container">
                <img
                    :src="require(`@/assets/Stage/Select/${type}-top.png`)"
                    alt=""
                    width="100%"
                />
                <div class="text">
                    <div class="type">{{ typeConfig.type }}</div>
                    <div class="header">關卡選擇</div>
                </div>
            </div>
            <BackBtn />
            <Layout
                :background-color="typeConfig.color"
                :copywriting="typeConfig.copywriting"
                @select="play"
            />
            <div class="float-footer image-container">
                <img
                    :src="require(`@/assets/Stage/Select/${type}-footer.png`)"
                    alt=""
                    width="100%"
                />
            </div>
        </wrapper>
    </div>
</template>

<script>
import PageGeneral from '@/mixins/PageGeneral';
import Layout from '@/components/Stage/Select/Layout.vue';
import BackBtn from '@/components/Button/BackButton.vue';

const CONFIG = {
    game1: {
        type: '含醣食物大挑戰',
        color: '#56a1e6',
        copywriting: {
            level1: '海王宮',
            level2: '冰雪村',
            level3: '太空城',
        },
    },
    game2: {
        type: '糖尿病知識大挑戰',
        color: '#3c9c74',
        copywriting: {
            level1: '青山塔',
            level2: '探索村',
            level3: '魔法城',
        },
    },
};
export default {
    mixins: [PageGeneral],
    components: { Layout, BackBtn },
    computed: {
        typeConfig() {
            return CONFIG[this.type];
        },
        type() {
            return this.$route.params.type;
        },
    },
    methods: {
        play({ level }) {
            this.goToRoute('Stage_Game', { level });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";
.select {
    .image-container.float {
        position: relative;
        .text {
            color: #fff;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            display: flex;
            flex-direction: column;
            align-items: center;
            .header {
                font-size: 2em;
                font-weight: bold;
            }
        }
    }
}
</style>
